import React from 'react';
import { Button, Typography, Box, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { connect,useDispatch } from 'react-redux';
import authActions from '../redux/features/auth/actions'

function UnauthorizedUser({logoutUser}){
    const dispatch = useDispatch()
    const handleLogout = async() => {
        sessionStorage.clear();
        dispatch(logoutUser)
         window.location.href = `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/oauth2/v2.0/logout`   
    }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f4f4f4',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: '40px',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%',
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Unauthorized Access
        </Typography>
        <Typography variant="body1" paragraph>
          You do not have permission to view this page
        </Typography>
        <Box sx={{ marginTop: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogout}
            sx={{ marginRight: '10px' }}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
UnauthorizedUser.propTypes = {
  logoutUser: PropTypes.func.isRequired,
};
const mapDispatchToProps = {
  logoutUser: authActions.logoutUser,
};
export default connect(null,mapDispatchToProps)(UnauthorizedUser);

